import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFacebookComponent } from './simple-icons-facebook.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFacebookComponent ],
    exports:      [ SimpleIconsFacebookComponent ],
    bootstrap:    []
})
export class SimpleIconsFacebookModule {}
